import ProcessGuides from "../components/ProcessGuides";
import AIAdoptionValue from "../components/AIAdoptionValue";
import React from "react";
import ConsultingServices, { ConnectorHighlights } from "../components/ConsultingServices";
import Hero from "../components/Hero";
import LatestUpdates from "../components/LatestUpdates";
import CTASection from "../components/CTASection";
import LogoStrip from "../components/LogoStrip";
import TechStack from "../components/TechStack";
import { IntegrationBand, StudySpotlight } from "../components/HomeGrowthSections";

const Home = () => {
    return (
        <main data-testid="home-page">
            <Hero />
            <IntegrationBand />
            <LogoStrip />
            <AIAdoptionValue />
            <ProcessGuides home />
            <TechStack />
            <ConnectorHighlights integrationsLabel />
            <ConsultingServices showConnectors={false} />
            <StudySpotlight />
            <LatestUpdates />
            <CTASection />
        </main>
    );
};

export default Home;
